interface GhostOverlayProps {
  /** Signed URL of the most recent earlier photo. */
  src: string;
  opacity?: number;
}

/**
 * Yesterday's face, faint, over today's preview.
 *
 * Mirrored to match the preview beneath it. The preview is flipped because an
 * unmirrored self-view is disorienting, while stored photos are kept unflipped;
 * drawing the ghost unmirrored over a mirrored preview would ask the user to
 * line their face up against its own reflection.
 *
 * This is the aiming aid, not the alignment. The stored frame is corrected by
 * the transform in `align.ts` — an overlay alone would still leave a timelapse
 * visibly shaky, because it cannot fix the frame after the fact.
 */
export function GhostOverlay({ src, opacity = 0.3 }: GhostOverlayProps) {
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      style={{ opacity }}
      className="pointer-events-none absolute inset-0 size-full -scale-x-100 object-cover"
    />
  );
}
